import { DataBean } from "../DataBean";

export class ProvisionData extends DataBean {

    public async getProvisionDataCatalog(year: any, month: any, page: any, recordsPerPage: any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "com.advantage.shared.Report_getProvisionDataCatalog_Number_Number_Number_Number", [year, month, page, recordsPerPage]);
    }

}